import { FC } from 'react';
import { useSelector } from 'react-redux';
import G17EcoLogo from '@g17eco/images/g17Eco.svg';

import { AppLayout } from '@layout/AppLayout';
import { RouteErrorBoundary } from '@features/error';
import { AppHeader } from '@features/header/AppHeader';
import Header from '@features/header';
import NotAuthorised from '@routes/not-authorised';
import { isStaff } from '@selectors/user';
import { ThemeShowcase } from '@routes/theme-showcase/ThemeShowcase';

import { themeShowcaseRoutes } from '@routes/theme-showcase/routes';
import { AppRouteInterface } from '@g17eco/types/routes';

const themeShowcaseAppRoute: AppRouteInterface = {
  appName: 'Theme Showcase',
  appIcon: G17EcoLogo, 
  routes: Object.values(themeShowcaseRoutes)
};

export const ThemeShowcaseRoute: FC = () => {
  const isUserStaff = useSelector(isStaff);

  return (
    <RouteErrorBoundary>
      <AppLayout
        Header={
          <Header>
            <AppHeader appRoute={themeShowcaseAppRoute} route={themeShowcaseRoutes.THEME_SHOWCASE} />
          </Header>
        }
      >
        {isUserStaff ? <ThemeShowcase /> : <NotAuthorised />}
      </AppLayout>
    </RouteErrorBoundary>
  );
};
